import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";

/*
 * @Author       : wangkai42@xdf.cn
 * @Date         : 2021-10-26 13:56:13
 * @LastEditors  : wangkai42@xdf.cn
 * @LastEditTime : 2021-10-26 14:17:16
 * @Description  : 点击获取验证码或者其他需要管控的用户行为触发
 */

/**
 * @Author: wangkai42@xdf.cn
 * @LastEditors: wangkai42@xdf.cn
 * @description: 点击获取验证码或者其他需要管控的用户行为触发
 * @param {*} config
 * @param {*} sucessCb
 * @param {*} errorCb
 * @return {*}
 */
// config说明
// app_id 必需 网关appId
// lang 非必需 默认zh-cn,支持语言
// area 非必需 指定滑块的弹出区域，如果不填写，则默认出现在整个页面的正中央，选填。如果填写，DOM元素必须存在，例如DOM元素id为test。则传入：“#test”
// next_width 非必需 弹出滑动框的宽度（单位px或者xx%）
// isTest 非必需 默认是生产环境。只有传递 isTest: true 时，才会请求测试环境
// 例子：
// {
//   app_id: 'xdf-edu',
//   isTest: true,
//   lang: 'en',
//   area: '#loginIndex',
//   next_width: '300px'
// }
function slide(config, sucessCb, errorCb) {
  try {
    if (window.XDFSlide) {
      window.XDFSlide.verify(config, function (mmvToken) {
        if (mmvToken) {
          sucessCb && sucessCb(mmvToken);
        }
      });
    }
  } catch (e) {
    errorCb && errorCb(e);
  }
}

export function slideAsync(_x) {
  return _slideAsync.apply(this, arguments);
}

function _slideAsync() {
  _slideAsync = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve, reject) {
              try {
                if (window.XDFSlide) {
                  window.XDFSlide.verify(config, function (mmvToken) {
                    if (mmvToken) {
                      resolve(mmvToken);
                    }
                  });
                }
              } catch (e) {
                reject();
              }
            });

          case 2:
            res = _context.sent;
            return _context.abrupt("return", res);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _slideAsync.apply(this, arguments);
}

export default slide;